import { ReactNode } from "react";
import { BottomNavigation } from "@/components/BottomNavigation";
import { MobileAppHeader } from "@/components/header/MobileAppHeader";

interface AppShellProps {
  children: ReactNode;
  title?: string;
  rightAction?: ReactNode;
}

export function AppShell({ children, title, rightAction }: AppShellProps) {
  return (
    <div className="min-h-screen bg-background">
      {/* Centered mobile frame on desktop */}
      <div className="mx-auto max-w-md md:max-w-lg lg:max-w-xl md:my-4 md:rounded-2xl md:shadow-xl md:border md:border-border/50 md:overflow-hidden md:min-h-[calc(100vh-2rem)] md:bg-background">
        <MobileAppHeader title={title} rightAction={rightAction} />
        <main className="pb-20 md:pb-6">
          {children}
        </main>
      </div>
      <BottomNavigation />
    </div>
  );
}
